<template>
  <b-container
    id="StdLogin"
    class="bv-example-row"
    fluid="true xl md sm xs"
    style="padding: 2rem 0rem"
  >
    <b-row class="justify-content-md-center">
      <p></p>
    </b-row>
    <b-row class="justify-content-md-left">
      <div v-if="memberShow">
        <b-row class="justify-content-md-left">
          <b-col xl="2" md="6">
            <div class="form-group frame_title" style="text-align: left">
              體育績優生獎助學金系統
            </div>
            <div
              class="form-group frame_title"
              style="text-align: left; color: red"
            >
              {{ inputData.usrData.name }}
            </div>
            <div class="form-group frame_title" style="text-align: left">
              同學，歡迎回來
            </div>

            <ul class="nav nav-pills flex-column">
              <li class="nav-item">
                <span>
                  <a
                    href="#"
                    class="nav-link active bg-info text-white rounded"
                    @click.prevent="getPersonalInformation()"
                    >個人資料</a
                  >
                  <hr
                    style="margin: 8px"
                    width="95%"
                    color="#987cb9"
                    size="1"
                  />
                </span>
              </li>
              <li v-if="NewCaseShow" class="nav-item">
                <span>
                  <a
                    href="#"
                    class="nav-link active bg-info text-white rounded"
                    @click.prevent="getAddNewCase()"
                    >新申請</a
                  >
                  <hr
                    style="margin: 8px"
                    width="95%"
                    color="#987cb9"
                    size="1"
                  />
                </span>
              </li>
              <li class="nav-item">
                <span>
                  <a
                    href="#"
                    class="nav-link active bg-info text-white rounded"
                    @click.prevent="getAllScholarship2()"
                    >瀏覽待審查</a
                  >
                  <hr
                    style="margin: 8px"
                    width="95%"
                    color="#987cb9"
                    size="1"
                  />
                </span>
              </li>
              <li class="nav-item">
                <span>
                  <a
                    href="#"
                    class="nav-link active bg-info text-white rounded"
                    @click.prevent="getAllScholarship()"
                    >瀏覽歷史</a
                  >
                  <hr
                    style="margin: 8px"
                    width="95%"
                    color="#987cb9"
                    size="1"
                  />
                </span>
              </li>

              <li class="nav-item">
                <span>
                  <a
                    href="#"
                    class="nav-link active bg-primary text-white rounded"
                    @click.prevent="logout()"
                    >登出</a
                  >
                  <hr
                    style="margin: 8px"
                    width="95%"
                    color="#987cb9"
                    size="1"
                  />
                </span>
              </li>
            </ul>
          </b-col>
          <b-col xl="10" md="6">
            <div id="app" class="well" style="padding: 0 1em">
              <div v-if="HistoryShow" class="overflow-auto">
                目前共 {{ total }}筆

                <b-tabs content-class="mt-3" justified>
                  <div
                    class="dataTables_scrollBody"
                    style="
                      font-size: 14px;
                      position: relative;
                      overflow: auto;
                      max-height: 100%;

                      border-bottom: 1px solid #111;
                      border-top: 1px solid #111;
                    "
                  >
                    <b-table-simple
                      class="ncut-table-menu-striped ncut-table-menu"
                      fixed
                      responsive
                      bgcolor="#FFFFFF"
                    >
                      <b-thead class="ncut-thead-menu">
                        <b-tr>
                          <b-th style="width: 50px; min-width: 1em"
                            >申請案件編號</b-th
                          >
                          <b-th style="width: 50px; min-width: 1em">學年</b-th>
                          <b-th style="width: 50px; min-width: 1em">學期</b-th>
                          <b-th style="min-width: 2em">申請項目</b-th>
                          <b-th style="min-width: 2em">主辦單位</b-th>
                          <b-th style="min-width: 5em">競賽分組</b-th>
                          <b-th style="min-width: 5em">競賽種類名稱</b-th>
                          <b-th style="min-width: 5em">組別</b-th>
                          <b-th style="width: 30px; min-width: 1em">名次</b-th>
                          <b-th style="min-width: 5em">申請日期</b-th>
                          <b-th style="min-width: 2em">目前狀態</b-th>
                          <b-th style="min-width: 2em">核准獎勵金</b-th>
                          <b-th style="width: 100px; min-width: 10em"
                            >申請證明文件</b-th
                          >
                          <b-th
                            v-if="ApplyShow"
                            style="width: 90px; min-width: 5em"
                            >操作</b-th
                          >
                        </b-tr>
                      </b-thead>
                      <b-tbody class="ncut-tbody-menu">
                        <b-tr
                          v-for="(i, index) in queryInfo"
                          :key="i.id"
                          :index="i.id"
                          :name="i.typeName"
                          v-bind:style="{
                            background:
                              selectedRowIndex == index ? headerColor : '',
                          }"
                          @click="selectedRowIndex = index"
                        >
                          <b-td style="text-align: left">
                            {{ i.id }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ i.schyy }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ i.smt }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ getItem(i.item) }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ getUnit(i.unit) }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ getCGroup(i.cGroup) }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ i.typeName }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ getGroup(i.group) }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ i.ranking }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ getToday(i.applyTime) }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ getIsComplete(i.isComplete, i.reason) }}
                          </b-td>
                          <b-td style="text-align: left">
                            {{ i.money }}
                          </b-td>
                          <b-td style="text-align: left">
                            <span class="sel-file" v-if="i.rowId2 != null">
                              <a
                                :href="
                                  './WebApi/Common/GetDocumentFile/' + i.rowId2
                                "
                                target="_blank"
                              >
                                <img src="@/assets/images/disk.png" />秩序冊
                              </a> </span
                            ><br />

                            <span class="sel-file" v-if="i.rowId3 != null">
                              <a
                                :href="
                                  './WebApi/Common/GetDocumentFile/' + i.rowId3
                                "
                                target="_blank"
                              >
                                <img
                                  src="@/assets/images/disk.png"
                                />得獎證明文件影印本 </a
                              ><br />
                            </span>
                            <span class="sel-file" v-if="i.rowId4 != null">
                              <a
                                :href="
                                  './WebApi/Common/GetDocumentFile/' + i.rowId4
                                "
                                target="_blank"
                              >
                                <img
                                  src="@/assets/images/disk.png"
                                />競賽辦法及賽程時間內容資料 </a
                              ><br />
                            </span>
                          </b-td>
                          <b-td v-if="ApplyShow">
                            <a
                              :href="
                                './WebApi/SportsExcellent/GetApplyPDF/' + i.id
                              "
                              target="_blank"
                            >
                              <img src="@/assets/images/disk.png" />
                              列印
                            </a>

                            <button
                              href="#"
                              @click.prevent="remove(i.id)"
                              class="btn btn-outline-danger"
                              type="button"
                              style="font-size: 14px"
                            >
                              刪除
                            </button>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </b-tabs>
              </div>
            </div>

            <PersonalInformation
              v-if="PIShow"
              @CaseSelect="CaseSelect"
            ></PersonalInformation>
            <AddNewCase v-if="AddNewCaseShow" @CaseSelect="CaseSelect" />
          </b-col>
        </b-row>
        <b-modal ref="q-modal" hide-footer title="請注意">
          <div class="d-block text-center">
            <h3>是否確認刪除此筆資料?</h3>
          </div>
          <b-button
            class="mt-3"
            variant="outline-danger"
            block
            @click="cancalRM"
            >取消刪除</b-button
          >
          <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
            >刪除確認</b-button
          >
        </b-modal>
      </div>
    </b-row>
  </b-container>
</template>
<script>
import * as tools from "../tool";
import PersonalInformation from "@/components/PersonalInformationView.vue";
import AddNewCase from "@/components/AddNewCaseView.vue";

export default {
  name: "StdLogin",
  components: {
    PersonalInformation,
    AddNewCase,
  },
  data() {
    return {
      eid: 0,
      NewCaseShow: false,
      HistoryShow: true,
      ApplyShow: false,
      PIShow: false,
      AddNewCaseShow: false,
      memberShow: this.$store.state.user2,
      em: "",
      content: {
        text1: "",
        text2: "",
      },
      user: {
        id1: "",
        id2: "",
        id3: "",
        sysId: 0, // 學生登入
        isLogin: true,
      },

      // captchaInfo:{text1:'',text2:'',text3:''},
      confirmData: null,
      captchaInfo: null,
      inputData: this.$store.state.inputData,
      queryInfo: null,
      total: 0,
      //inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
    };
  },
  computed: {
    filteredDocs: function () {
      let data = [];

      if (this.queryInfo != null) {
        data = this.queryInfo.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  methods: {
    getTimeSet: function () {
      var vm = this;
      this.$http
        .get("./WebApi/SportsExcellent/GetTimeSet/")
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data[0];

            var date1 = new Date(vm.inputData2.date1);
            var date2 = new Date(vm.inputData2.date2);

            // 取得現在的時間
            var now = new Date();

            // 進行比較
            if (now >= date1 && now <= date2) {
              vm.NewCaseShow = true;
            } else {
              vm.NewCaseShow = false;
            }
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
    getTimeSetShow() {
      var now = new Date();

      if (
        now.toISOString() >= this.inputData2.date1 &&
        now <= this.inputData2.date2
      )
        this.NewCaseShow = true;
      else this.NewCaseShow = false;
    },
    CaseSelect(id) {
      if (id == 1) {
        this.closeShow();
        this.memberShow = true;
        this.getAllScholarship2();
      } else if (id == 2) {
        this.closeShow();
        this.PIShow = true;
        this.getAllScholarship2();
      }
    },
    remove(eid) {
      this.eid = eid;
      this.$refs["q-modal"].show();
    },
    cancalRM() {
      this.$refs["q-modal"].hide();
    },

    confirmRM() {
      this.$refs["q-modal"].hide();
      var vm = this;
      this.$http
        .get("./WebApi/SportsExcellent/DeleteApplyPDF/".concat(this.eid))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,刪除成功");
            vm.getAllScholarship2();
          } else {
            tools.showAlert(vm, "danger", "對不起,刪除失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
    },
    getAddNewCase() {
      this.closeShow();
      this.AddNewCaseShow = true;
    },
    getPersonalInformation() {
      this.closeShow();
      this.PIShow = true;
    },
    closeShow() {
      this.HistoryShow = false;
      this.ApplyShow = false;
      this.PIShow = false;
      this.AddNewCaseShow = false;
    },
    getToday(updateTime) {
      var dd = new Date(updateTime);
      var today = dd.getDate().toString().padStart(2, "0"); //內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, "0"); //January is 0!
      var yyyy = dd.getFullYear();
      return tools.stringFormat("{0}-{1}-{2}", yyyy, mm, today);
    },
    getIsComplete(id, reason) {
      var ret;
      if (id == 0) ret = "待審查";
      else if (id == 1) ret = "符合";
      else if (id == 2) {
        ret = "不符合(" + reason + ")";
      } else if (id == 3) {
        ret = "資料錯誤(" + reason + ")";
      }

      return ret;
    },
    getItem(id) {
      var ret;
      if (id == 0) ret = "運動績優保送";
      else if (id == 1) ret = "校內比賽";
      else if (id == 2) ret = "校外比賽";
      return ret;
    },
    getUnit(id) {
      var ret;
      if (id == 0) ret = "體育室";
      else if (id == 1) ret = "中華民國大專院校體育總會(含聯賽)";
      else if (id == 2) ret = "其他";

      return ret;
    },
    getCGroup(id) {
      var ret;
      if (id == 0) ret = "公開組個人賽";
      else if (id == 1) ret = "一般組個人賽";
      else if (id == 2) ret = "公開組團體賽";
      else if (id == 3) ret = "一般組團體賽";

      return ret;
    },
    getGroup(id) {
      var ret;
      if (id == 0) ret = "男子組";
      else if (id == 1) ret = "女子組";
      else if (id == 2) ret = "混合組";

      return ret;
    },

    getAllScholarship() {
      this.closeShow();
      this.HistoryShow = true;
      var vm = this;
      this.$http
        .get(
          "./WebApi/SportsExcellent/GetAllScholarship/".concat(
            vm.inputData.usrData.id
          )
        )
        .then(function (response) {
          if (response.data != null) {
            vm.queryInfo = response.data;
            vm.total = response.data.length;
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },
    getAllScholarship2() {
      this.closeShow();
      this.HistoryShow = true;
      var vm = this;
      this.$http
        .get(
          "./WebApi/SportsExcellent/GetAllScholarship2/".concat(
            vm.inputData.usrData.id
          )
        )
        .then(function (response) {
          if (response.data != null) {
            vm.queryInfo = response.data;
            vm.total = response.data.length;
            if (vm.total >= 1) vm.ApplyShow = true;
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
        });
    },
    logout() {
      alert("登出成功");
      window.location.reload();
      window.location.replace("/");
    },
  },
  created() {
    console.log("======created StdLoginView =====");

    this.getTimeSet();
    //this.getTimeSetShow();
  },
  mounted() {
    console.log("======mounted StdLoginView  =====");
    this.getAllScholarship2();
  },
};
</script>
<style scoped>
</style>
